import * as types from './types';

export const showModal = (modalType, modalProps) => ({ type: types.SHOW, modalType, modalProps });

export const hideModal = () => ({ type: types.HIDE });
